import { createSelector } from "reselect";

const selectNotificationsState = (state) => state.notifications;

const selectNotifications= () =>
  createSelector(selectNotificationsState, (notificationsState) => notificationsState.notifications);


const selectSystemNotifications= () =>
  createSelector(selectNotificationsState, (notificationsState) => notificationsState.systemNotifications);

export { selectNotifications, selectSystemNotifications };
